import React, {Component} from 'react';
import {connect} from 'react-redux';
import Loader from "../../../../../../../../components/sprite/components/loader";
import Avatar from "../../../../../../../../components/avatar";
import './index.css';
import {permissionCleaner, APP_URL} from "../../../../../../../../utils";

class ViewCollaboratorsList extends Component {
    render() {
        if(this.props.findCollaborators !== null){
            const collaborators = this.props.findCollaborators && Array.isArray(this.props.findCollaborators.collaborators)
                ? this.props.findCollaborators.collaborators
                : [];

            if (collaborators.length === 0) {
                return (
                    <div className="view-collaborators-list border-bottom p-4 text-center text-muted">
                        No collaborators found
                    </div>
                );
            }

            return (
                <div className="view-collaborators-list border-bottom">
                    {
                        collaborators.map(collaborator => (
                            <div key={collaborator.id}>
                                <div className="d-flex align-items-center">
                                    {
                                        collaborator.type === 'user'
                                        ?
                                            <Avatar size={36} className="mr-3 border-0" src={`${APP_URL}/account/avatar/${collaborator.id}`} />
                                        :
                                            <Avatar size={36} className="mr-3 border-0" src={'/img/collaborators-group.svg'} />
                                    }
                                    <div className="text-truncate">
                                        {
                                            collaborator.name
                                            ?
                                                <div className="text-nowrap">
                                                    <strong>{collaborator.name}</strong> - {collaborator.email} - <em>({permissionCleaner(collaborator.permission)})</em>
                                                </div>
                                            :
                                                <div className="text-nowrap">{collaborator.email} - <em>({permissionCleaner(collaborator.permission)})</em></div>
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            );
        } else {
            return (
                <div className="p-4 d-flex justify-content-center align-items-center" style={{ minHeight: '120px' }}>
                    <Loader/>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        findCollaborators : state.sharingDetailsReducer.findCollaborators,
    };
};

export default connect(mapStateToProps)(ViewCollaboratorsList);
